import { useMutation } from "@tanstack/react-query";

import { IPassword } from "../../interfaces/services";
import api from "../apiClient";

interface IPayload {
    token: string;
    creds: IPassword;
    setIsSuccess: Function;
    setApiError: Function;
    setIsProcessing: Function;
};

interface IResponse {
    error?: string;
    message: string;
    statusCode: number;
};

const useResetPassword = () => {
    const mutationFn = async (data: IPayload): Promise<IResponse> => {
        const res = await api.patch(`users/reset-password/${data.token}`, data.creds);
        return res.data;
    };

    return useMutation({
        mutationFn,
        onSuccess: (response: IResponse, variables: IPayload) => {
            if (response) {
                variables.setIsSuccess(true);
            }
        },
        onError: (error: any, variables: IPayload) => {
            variables.setApiError(error?.response?.data?.message ?? "An error occurred. Please try again.");
        },
        onSettled: (data: IResponse | undefined, error: IResponse | null, variables: IPayload) => {
            variables.setIsProcessing(false);
        },
    });
};

export default useResetPassword;